export enum StageType {
  TestStart = 'testStart',
  TestFinishSuccess = 'testFinishSuccess',
  TestFinishFailed = 'testFinishFailed',
}
